import React from 'react'
import '../assets/css/Apropos.css'
import decor1 from '../assets/images/decor1.png'
import rectangle from '../assets/images/rectangle.png'
import dots from '../assets/images/dots.png'
import code from '../assets/images/code.png'

const Apropos = () => {
   let details = "<p>Tout d'abord, j'ai acquis une solide expérience dans le développement à la fois du côté frontend et backend, ce qui me permet d'avoir une vue d'ensemble et d'apporter des solutions globales aux projets.En tant que développeur, je suis constamment à l'affût des dernières tendances et évolutions technologiques. J'aime relever les défis techniques et résoudre des problèmes complexes. Ma polyvalence me permet de m'adapter rapidement à de nouveaux langages et frameworks, ce qui est essentiel dans un environnement en constante évolution."
   details += "</br> </br>De plus, ma solide expérience en programmation et en gestion de bases de données me permet de créer des systèmes efficaces et extensibles. Je suis particulièrement compétent dans des langages tels que Java, Node.js, php et python ainsi que dans l'utilisation de frameworks comme Nest, Express et Spring, pour n'en nommer que quelques-uns. J'ai également travaillé avec diverses bases de données, des bases de données relationnelles aux bases de données NoSQL, ce qui me permet de choisir la meilleure solution pour chaque projet."
   details += "</br> </br>Enfin, je suis également un excellent communicateur et je sais collaborer efficacement en équipe. Je pense que la synergie entre les membres d'une équipe est essentielle pour réussir un projet, et je suis toujours prêt à apporter mes compétences et à apprendre des autres.</p></br>"

  return (
    <>
      <main id="about">
         <div className="aboutMe-container">
            <div className="about-decor">
               <div className="about-dots">
               <img src={decor1} alt="" />
               </div>
               <div className="about-rect">
               <img src={rectangle} alt="" />
               </div>
               <div className="about-shady">
               <img src={dots} alt="" />
               </div>
            </div>
            <div className="abouMe-row">
               <div
               className=" col-lg-6 col-md-5 col-sm-12 about-img"
               data-aos="fade-up-right"
               >
                  <img src={code} alt=''/>
               </div>
               <div
               className=" col-lg-6 col-md-7  col-sm-12 about_myinfo"
               data-aos="fade-up-left"
               >
               <div className="title">
                  <h2>A Propos</h2>
                  <h3>POURQUOI MOI POUR VOTRE PROCHAIN PROJET</h3>
               </div>
               <div className="about-description">
                  <div id="foo" unselectable="on" class="unselectable">
                     <div
                     dangerouslySetInnerHTML={{
                        __html: `${details}`,
                     }}
                     />
                  </div>
               </div>

               <div className="itscv">
                  <a
                     href="https://drive.google.com/file/d/1cMqhzDoTbDFXpT2WL9KPlHAAdsqRsr72/view?usp=sharing"
                     download="STILISKY_CV.pdf"
                     target="_blank"
                     rel="noopener noreferrer"
                  >
                     <button className="download-cv">
                     Mon Cv <i class="bx bx-download"></i>
                     </button>
                  </a>
               </div>
               </div>
            </div>
         </div>
      </main>
    </>
  )
}

export default Apropos